<template>
  <div>
    <slot :toggleCredit="toggleCredit" :$id="$id"></slot>
  </div>
</template>

<script lang="js">
import Swiper, { Navigation } from 'swiper';
import leftPad from '../../js/util/leftPad';

Swiper.use([Navigation]);

export default  {
  name: 'ahc-exhibition-slideshow',
  inject: {
    exhibition: {
      default: () => ({})
    }
  },
  data() {
    return {
      swiperInstance: null,
    }
  },
  methods: {
    initSwiper() {
      const swiperContainer = this.$el.querySelector('.exhibition-slideshow');
      const swiperSlides = this.$el.querySelectorAll('.exhibition-slideshow__slide');
      const slideCounters = this.$el.querySelectorAll('.exhibition-slideshow__slide-caption-counter');

      Array.prototype.forEach.call(slideCounters, (counter, index) => {
        counter.textContent = leftPad(index + 1, 2, '0') + '/' + leftPad(swiperSlides.length, 2, '0');
      });

      this.swiperInstance = new Swiper(swiperContainer, {
        loop: true,
        slidesPerView: 'auto',
        loopedSlides: 2,
        a11y: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });
    },
    toggleCredit(e) {
      if (e.target.classList.contains('exhibition-slideshow__slide-caption-credit-link')) {
        const index = parseInt(e.target.getAttribute('data-index'), 10);
        const slideAndClones = this.$el.querySelectorAll(`[data-swiper-slide-index="${index}"]`);

        Array.prototype.forEach.call(slideAndClones, slide => {
          const caption = slide.querySelector('.exhibition-slideshow__slide-caption');

          if (caption) {
            const captionText = caption.querySelector('.exhibition-slideshow__slide-caption-caption');
            const creditText = caption.querySelector('.exhibition-slideshow__slide-caption-credit');
            const button = caption.querySelector('.exhibition-slideshow__slide-caption-credit-link');

            const creditShown = caption.classList.contains('exhibition-slideshow__slide-caption--credit-shown');

            if (creditShown) {
              caption.classList.remove('exhibition-slideshow__slide-caption--credit-shown');

              if (captionText) {
                captionText.setAttribute('aria-hidden', 'false');
              }

              if (creditText) {
                creditText.setAttribute('aria-hidden', 'true')
              }

              if (button) {
                button.setAttribute('aria-expanded', 'false');
              }
            } else {
              caption.classList.add('exhibition-slideshow__slide-caption--credit-shown');

              if (captionText) {
                captionText.setAttribute('aria-hidden', 'true');
              }

              if (creditText) {
                creditText.setAttribute('aria-hidden', 'false')
              }

              if (button) {
                button.setAttribute('aria-expanded', 'true');
              }
            }
          }
        });
      }
    },
    onExhibitionRefresh() {
      this.swiperInstance.update();
    }
  },
  mounted() {
    this.initSwiper();

    if (this.exhibition.$on) {
      this.exhibition.$on('refresh', this.onExhibitionRefresh);
    }
  },
  beforeDestroy() {
    if (this.exhibition.$off) {
      this.exhibition.$off('refresh', this.onExhibitionRefresh);
    }

    this.swiperInstance.destroy(true);
  }
}
</script>
